import React, { useState, useMemo, useEffect } from "react";
import { dealjacketActions, orgActions } from "../../actions";
import { connect } from "react-redux";
import { SERVER_URL } from "../../constants/constants.js";

import Uploady, { useItemProgressListener, useUploady } from "@rpldy/uploady";
import { Line } from "rc-progress";



const ConfirmingUploadButton = (props) => {
    const { showFileUpload } = useUploady();
    const { current_org_name, use_doctypes, doctypes, selectedDocType, setSelectedDocType, single_org_user, allow_file_splitting,
        splitFile, handleChangeSplitFile } = props;

    const [confirmed, setConfirmed] = useState(false);
    const [inputOrgName, setInputOrgName] = useState('');
    const [tryAgain, setTryAgain] = useState(false);






    const confirm = () => {
        if (inputOrgName === current_org_name) {
            setConfirmed(true);
            setTryAgain(false);
            showFileUpload();
        } else {
            if (single_org_user) {
                setConfirmed(true);
                setTryAgain(false);
                showFileUpload();
            }
            setTryAgain(true);
        }
    }

    const handleButtonClick = () => {
        setConfirmed(false);
    };

    const onInputChange = (e) => {
        const { value } = e.target;
        setInputOrgName(value.trim());
    }

    const onChangeDocType = (e) => {
        setSelectedDocType(e.target.value);
    }

    const doctypes_html = doctypes?.map((doctype, i) => (
        <>
            <option key={doctype} id="doctype" name="doctypes" value={doctype}>
                {doctype}
            </option>
        </>
    ));

    return (
        <>
            {confirmed &&
                <div {...props} className="formButton" onClick={handleButtonClick}>
                    Browse
                </div>
            }
            {!confirmed &&
                <>
                    <h3>Sanity Check!</h3>
                    <br />
                    You are now uploading files to: <b>{current_org_name}</b><br /><br />
                    {
                        (use_doctypes) &&
                        <>
                            <span className="uploadFineprint">
                                This org uses Doc Types. Please select one:<br /><br />
                            </span>
                            <select className="orgDropdown"
                                value={selectedDocType ? selectedDocType : "select a doc type"}
                                onChange={(e) => onChangeDocType(e)}
                            >
                                <option key="select a doc type" id="doctype" name="doctypes" value="select a doctype">
                                    select a doc type
                                </option>
                                {doctypes_html}
                            </select>
                            <br /><br />
                        </>
                    }
                    {
                        (allow_file_splitting) &&
                        <div className="uploadFineprint">
                            {
                                (splitFile) && (<input type="checkbox" checked onChange={handleChangeSplitFile} />)
                            }
                            {
                                (!splitFile) && (<input type="checkbox" onChange={handleChangeSplitFile} />)
                            }
                            &nbsp;split upload into single-page files<br /><br />
                        </div>
                    }

                    {
                        (single_org_user) &&
                        <>

                            <button onClick={confirm}><a>Continue</a></button><br />
                        </>
                    }
                    {
                        (!single_org_user) &&
                        <>
                            <hr />
                            <br />
                            <h3 className="errormessage">Are You Uploading to the Right Org?</h3><br />
                            <div className="uploadInstructions">
                                <span className="uploadFineprint">If no, you can change the Org using the dropdown in the menu above</span><br />
                                <span className="uploadFineprint">If yes, then enter the Org name exactly as it appears above (including capitalization) into the input field below:</span><br />
                            </div>
                            {(tryAgain) &&
                                <>
                                    <span className="tryAgain">Try again.</span><br /><br />
                                </>
                            }
                            <input className="uploadConfirm" type="text" size="40" onChange={onInputChange} placeholder="enter org name here..."></input><br /><br />
                            <button onClick={confirm}><a>Yes, this is the right Org. Continue!</a></button><br />
                        </>
                    }


                </>
            }
        </>
    )


}


const UploadProgress = () => {
    const [uploads, setUploads] = React.useState({});
    const progressData = useItemProgressListener();

    if (progressData && progressData.completed) {
        const upload = uploads[progressData.id] ||
            { name: progressData.url || progressData.file.name, progress: [0] };

        if (!~upload.progress.indexOf(progressData.completed)) {
            upload.progress.push(progressData.completed);

            setUploads({
                ...uploads,
                [progressData.id]: upload,
            });
        }
    }

    const entries = Object.entries(uploads);
    return <div>
        {entries
            .map(([id, { progress, name }]) => {
                const lastProgress = progress[progress.length - 1];

                return <div key={id}>
                    <Line
                        style={{ height: "10px", marginTop: "20px" }}
                        strokeWidth={3}
                        strokeColor={lastProgress === 100 ? "#3a8562" : "#700382"}
                        percent={lastProgress}
                    />
                    <p className="fineprint">{id} : {name}</p>
                </div>;
            })}
    </div>;
};


const UploadJacket = (props) => {

    const { authentication, org, getDocTypes } = props;
    const jwt = authentication.jwt;
    const user_orgs = authentication.user.orgs;
    const org_id = Number(org.current_org_id);
    const upload_url = SERVER_URL + "/org/" + org_id + "/dealjacket?token=" + jwt;


    const [skipAirtable, setSkipAirtable] = useState(false);
    const [selectedDocType, setSelectedDocType] = useState('Deal Jacket');
    const [splitFile, setSplitFile] = useState(false);

    const current_org = user_orgs.filter(
        (org) => org.org_id === org_id
    )[0];

    const current_org_name = current_org.display_name;
    const use_doctypes = current_org.allow_doc_types;
    const allow_file_splitting = current_org.allow_file_splitting;
    const single_org_user = user_orgs?.length === 1;
    const user_doctypes = authentication?.user?.doctypes?.filter((doctype) => doctype.org_id === org.current_org_id);
    const org_doctypes = org?.doc_types;


    const doctypes = (user_doctypes?.length > 0) ? user_doctypes?.map((doctype) => doctype.doc_type_name) : org_doctypes?.map((doctype) => doctype.doc_type);

    const handleChangeSplitFile = () => {
        setSplitFile(!splitFile);
    }

    useEffect(() => {
        getDocTypes(current_org?.org_id);
    }, [])


    return (

        <div className="upload">
            <Uploady
                multiple
                destination={{ url: upload_url + "&doctype=" + selectedDocType }}
                sendWithFormData
                params={{ skip_airtable: skipAirtable, splitFile: splitFile }}
            >
                {(use_doctypes && doctypes?.length > 0) &&
                    <ConfirmingUploadButton
                        current_org_name={current_org_name}
                        use_doctypes={use_doctypes}
                        doctypes={doctypes}
                        selectedDocType={selectedDocType}
                        setSelectedDocType={setSelectedDocType}
                        setSkipAirtable={setSkipAirtable}
                        single_org_user={single_org_user}
                        allow_file_splitting={allow_file_splitting}
                        splitFile={splitFile}
                        handleChangeSplitFile={handleChangeSplitFile}
                    />
                }
                {(!use_doctypes) &&
                    <ConfirmingUploadButton current_org_name={current_org_name} setSkipAirtable={setSkipAirtable} allow_file_splitting={allow_file_splitting} splitFile={splitFile} />
                }
                <UploadProgress />
            </Uploady>
        </div>

    );
}

function mapStateToProps(state) {
    const { authentication, org } = state;
    return {
        authentication,
        org,
    };
}

const actionCreators = {
    uploadJacket: dealjacketActions.uploadJacket,
    getDocTypes: orgActions.getDocTypes,
};

const connectedUploadJacket = connect(
    mapStateToProps,
    actionCreators
)(UploadJacket);
export { connectedUploadJacket as UploadJacket };
